import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Oauth2ScopesService } from '../scopes-service';

@Component({
  selector: 'app-create-scope',
  templateUrl: './create-oauth2-scope.component.html',
  styleUrls: ['./create-oauth2-scope.component.scss'],
  standalone: false,
})
export class CreateOauth2ScopeComponent implements OnInit {
  public form: UntypedFormGroup;
  public isDisabled = false;

  constructor(
    private oauth2ScopesService: Oauth2ScopesService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl('', [Validators.required]),
      name: new UntypedFormControl('', Validators.required),
      description: new UntypedFormControl('', Validators.required),
    });
  }

  onSubmit(): void {
    if (!this.form.valid) {
      this.alertService.openErrorSnack('Form invalid, make sure you have filled out the required fields.');
      return;
    }
    this.isDisabled = true;
    this.oauth2ScopesService.createScope(this.id, this.name, this.description).subscribe(
      () => {
        this.alertService.openSuccessSnack('Scope created');
        this.goBack();
      },
      (err: HttpErrorResponse) => this.alertService.openErrorSnack('Error creating scope: ' + err.error.message),
      () => (this.isDisabled = false),
    );
  }

  onCancel(): void {
    this.goBack();
  }

  goBack(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  get id(): string {
    return this.form.get('id').value;
  }

  get name(): string {
    return this.form.get('name').value;
  }

  get description(): string {
    return this.form.get('description').value;
  }
}
